import { thousandSeparator } from './utils';
import regEx from './regex';
/**
 * Amount Paid
 */
export var amountPaidMessage = function (amountPaid, nominalValue, q) {
    if (amountPaid < nominalValue * q) {
        return "Amount paid value may not be less than " + thousandSeparator((nominalValue * q).toFixed(2)) + " USD (quantity*nominal value)";
    }
    if (amountPaid > 1000000000000) {
        return ('Amount paid value may not be more than ' +
            thousandSeparator(1000000000000) +
            ' USD');
    }
    return undefined;
};
/**
 * Exercise Price
 */
export var exercisePriceMessage = function (exercisePrice) {
    if (exercisePrice < 0) {
        return 'Exercise price may not be less than 0';
    }
    if (exercisePrice > 1000000000000) {
        return "Exercise price may not be more than " + thousandSeparator(1000000000000);
    }
    return undefined;
};
/**
 * Holder Email
 */
export var holderEmailMessage = function (holderEmail, holderName) {
    if (!holderName && !holderEmail) {
        return 'Holder email and/or name is required';
    }
    if (holderEmail && regEx.email.test(holderEmail.toLowerCase()) === false) {
        return 'Invalid email';
    }
    if (holderEmail.length > 100) {
        return 'Email may not be longer than 100 characters';
    }
    return undefined;
};
export var feebackTypeEmail = function (holderEmail, holderName) {
    if (!holderName && !holderEmail) {
        return 'info';
    }
    if (holderEmail && regEx.email.test(holderEmail.toLowerCase()) === false) {
        return 'warn';
    }
    if (holderEmail.length > 100) {
        return 'warn';
    }
    return undefined;
};
/**
 * Holder Name
 */
export var holderNameMessage = function (holderName, holderEmail) {
    if (!holderName && !holderEmail) {
        return 'Holder name and/or email is required';
    }
    if (holderName.length > 100) {
        return 'Name may not be longer than 100 characters';
    }
    return undefined;
};
export var feebackTypeName = function (holderName, holderEmail) {
    if (!holderName && !holderEmail) {
        return 'info';
    }
    if (holderName.length > 100) {
        return 'warn';
    }
    return undefined;
};
/**
 * Principal
 */
export var principalMessage = function (principal) {
    if (principal <= 0) {
        return 'Principal may not be 0 or less';
    }
    if (principal > 1000000000000) {
        return "Principal may not be more than " + thousandSeparator(1000000000000);
    }
    return undefined;
};
/**
 * Principal with limitation availablePrincipal
 */
export var principalWithLimitationMessage = function (principal, availablePrincipal) {
    if (principal <= 0) {
        return 'Principal may not be 0 USD or less';
    }
    if (principal > 1000000000000) {
        return "Principal may not be more than " + thousandSeparator(1000000000000) + " USD";
    }
    if (typeof availablePrincipal === 'number') {
        if (principal > availablePrincipal) {
            return "Principal may not be more than " + thousandSeparator(availablePrincipal) + " USD";
        }
    }
    return undefined;
};
/**
 * Purchase Price
 */
export var purchasePriceMessage = function (purchasePrice) {
    if (purchasePrice < 0) {
        return 'Purchase price may not be less than 0';
    }
    if (purchasePrice > 1000000000000) {
        return "Purchase price may not be more than " + thousandSeparator(1000000000000);
    }
    return undefined;
};
/**
 * Plansize
 */
export var planSizeMessage = function (availablePlanSize, planSize) {
    if (parseInt(planSize) > availablePlanSize) {
        return 'Plan size may not be more than available plan size';
    }
    return undefined;
};
/**
 * Quantity with limitation availableQuantity
 */
export var quantityWithLimitationMessage = function (quantity, availableQuantity) {
    if (quantity < 1) {
        return 'Quantity may not be less than 1';
    }
    if (quantity > availableQuantity) {
        return "Quantity may not be more than " + availableQuantity;
    }
    return undefined;
};
/**
 * Quantity
 */
export var quantityMessage = function (quantity) {
    if (quantity < 1) {
        return 'Quantity may not be less than 1';
    }
    if (quantity > 2147483647) {
        return "Quantity may not be more than " + thousandSeparator(2147483647);
    }
    return undefined;
};
//# sourceMappingURL=messages.js.map